import { render, staticRenderFns } from "./lt-taskim-btn.vue?vue&type=template&id=6626322e&scoped=true&"
import script from "./lt-taskim-btn.vue?vue&type=script&lang=js&"
export * from "./lt-taskim-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626322e",
  null
  
)

export default component.exports